<template>
  <div class="click-verification">
    <div class="verification-modal" v-if="showModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>请在下图依次点击</h3>
          <div class="target-text">{{ targetText }}</div>
          <div class="close-btn" @click="closeModal">×</div>
        </div>
        
        <div class="image-container" @click="handleImageClick">
          <img ref="verificationImage" :src="imageSrc" alt="验证图片" />
          <!-- 渲染目标文字 -->
          <div 
            v-for="(pos, index) in wordPositions" 
            :key="index"
            class="word-to-click"
            :style="{
              left: pos.x + 'px',
              top: pos.y + 'px'
            }"
          >{{ pos.char }}</div>
          <!-- 渲染点击标记 -->
          <div 
            v-for="(point, index) in clickPoints" 
            :key="index"
            class="click-point"
            :style="{
              left: point.x + 'px',
              top: point.y + 'px',
              backgroundColor: point.color
            }"
          >{{ index + 1 }}</div>
        </div>
        
        <div class="modal-footer">
          <van-button class="refresh-btn" @click="refreshVerification" type="default" :disabled="isLoading">
            {{ isLoading ? '重置中...' : '重置' }}
          </van-button>
          <van-button 
            class="confirm-btn" 
            type="primary" 
            @click="confirmVerification"
            :disabled="clickPoints.length < targetText.length"
          >
            验证
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClickVerification',
  data() {
    return {
      showModal: false,
      targetText: '',
      imageSrc: '',
      clickPoints: [],
      clickedIndices: [], // 记录已点击的文字索引
      correctOrder: [],
      imageWidth: 0,
      imageHeight: 0,
      wordPositions: [],
      imageOptions: [
        require('../assets/images/xcsh.png')
      ],
      // 50个常用字
      commonChars: ['的', '一', '是', '在', '我', '有', '和', '人', '你', '他', '她', '它', '这', '那', '要', '来', '去', '大', '小', '多', '少', '上', '下', '左', '右', '前', '后', '里', '外', '天', '地', '日', '月', '水', '火', '山', '石', '田', '土', '木', '金', '水', '火', '土', '中', '国', '人', '民', '学', '生'],
      // 26个字母
      letters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      // 10个数字
      numbers: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
      // 加载状态
      isLoading: false
    };
  },
  methods: {
    show() {
      this.showModal = true;
      this.initializeVerification();
    },
    closeModal() {
      this.showModal = false;
      this.resetVerification();
    },
    resetVerification() {
      this.clickPoints = [];
      this.clickedIndices = [];
      this.correctOrder = [];
      this.wordPositions = [];
    },
    initializeVerification() {
      this.resetVerification();
      
      // 随机生成2-3个字符的目标文字
      this.targetText = this.generateRandomText();
      
      // 随机选择图片
      this.imageSrc = this.imageOptions[Math.floor(Math.random() * this.imageOptions.length)];
      
      // 延迟计算位置，确保图片加载完成
      setTimeout(() => {
        this.calculateWordPositions();
      }, 1000);
    },
    
    // 生成随机文本，2-3个字符
    generateRandomText() {
      // 合并所有字符源
      const allChars = [...this.commonChars, ...this.letters, ...this.numbers];
      // 随机生成2-3个字符
      const length = Math.floor(Math.random() * 2) + 2; // 2或3
      let result = '';
      
      for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * allChars.length);
        result += allChars[randomIndex];
      }
      
      return result;
    },
    refreshVerification() {
      // 防止重复调用
      if (this.isLoading) {
        return;
      }
      
      this.isLoading = true;
      // 调用初始化方法
      this.initializeVerification();
      // 重置加载状态
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);
    },
    calculateWordPositions() {
      const img = this.$refs.verificationImage;
      if (img) {
        this.imageWidth = img.offsetWidth;
        this.imageHeight = img.offsetHeight;
        
        // 为每个文字生成随机位置，确保位置不重叠
        const minDistance = 80; // 文字之间的最小距离
        
        for (let i = 0; i < this.targetText.length; i++) {
          let x, y;
          let isPositionValid = false;
          
          // 尝试生成有效的位置
          for (let attempt = 0; attempt < 100; attempt++) {
            // 生成随机位置，留出边距
            x = Math.random() * (this.imageWidth - 100) + 50;
            y = Math.random() * (this.imageHeight - 80) + 40;
            
            // 检查是否与已有文字位置太近
            isPositionValid = true;
            for (const pos of this.wordPositions) {
              const distance = Math.sqrt(Math.pow(x - pos.x, 2) + Math.pow(y - pos.y, 2));
              if (distance < minDistance) {
                isPositionValid = false;
                break;
              }
            }
            
            if (isPositionValid) {
              break;
            }
          }
          
          // 如果尝试多次后仍然没有找到有效位置，使用最后生成的位置
          this.wordPositions.push({ x, y, char: this.targetText[i] });
          this.correctOrder.push(i);
        }
      }
    },
    handleImageClick(event) {
      const img = this.$refs.verificationImage;
      if (!img) return;
      
      // 确保点击数不超过字数
      if (this.clickPoints.length >= this.targetText.length) {
        return;
      }
      
      const rect = img.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      
      // 检查是否点击在文字位置附近
      let clickedIndex = -1;
      this.wordPositions.forEach((pos, index) => {
        const distance = Math.sqrt(Math.pow(x - pos.x, 2) + Math.pow(y - pos.y, 2));
        if (distance < 40) {
          clickedIndex = index;
        }
      });
      
      if (clickedIndex !== -1) {
        // 检查该文字是否已经被点击过
        if (!this.clickedIndices.includes(clickedIndex)) {
          // 添加点击点
          const color = this.getRandomColor();
          this.clickPoints.push({ x, y, color });
          this.clickedIndices.push(clickedIndex);
        }
      }
    },
    getRandomColor() {
      const colors = ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#909399'];
      return colors[Math.floor(Math.random() * colors.length)];
    },
    confirmVerification() {
      if (this.clickPoints.length === this.targetText.length) {
        // 检查点击顺序是否正确
        const clickedIndices = [];
        this.clickPoints.forEach((point, index) => {
          // 找到点击点对应的文字索引
          let closestIndex = -1;
          let minDistance = Infinity;
          
          this.wordPositions.forEach((pos, posIndex) => {
            const distance = Math.sqrt(Math.pow(point.x - pos.x, 2) + Math.pow(point.y - pos.y, 2));
            if (distance < minDistance) {
              minDistance = distance;
              closestIndex = posIndex;
            }
          });
          
          if (closestIndex !== -1) {
            clickedIndices.push(closestIndex);
          }
        });
        
        // 验证点击顺序是否与目标文字顺序一致
        let isOrderCorrect = true;
        for (let i = 0; i < clickedIndices.length; i++) {
          if (clickedIndices[i] !== i) {
            isOrderCorrect = false;
            break;
          }
        }
        
        if (isOrderCorrect) {
          // 点击顺序正确，验证成功
          this.showModal = false;
          this.$emit('verification-success');
        } else {
          // 点击顺序错误，重置验证
          this.$toast('点击顺序错误，请重新验证');
          this.refreshVerification();
        }
      } else if (this.clickPoints.length < this.targetText.length) {
        this.$toast('请点击所有文字');
      }
    }
  }
};
</script>

<style scoped>
.click-verification {
  position: relative;
}

.verification-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  border-radius: 12px;
  padding: 20px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.modal-header h3 {
  margin: 0;
  font-size: 16px;
  color: #323233;
}

.target-text {
  font-size: 18px;
  font-weight: bold;
  color: #409EFF;
}

.close-btn {
  font-size: 24px;
  cursor: pointer;
  color: #909399;
}

.image-container {
  position: relative;
  margin-bottom: 20px;
  border-radius: 8px;
  overflow: hidden;
}

.image-container img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.word-to-click {
  position: absolute;
  font-size: 20px;
  font-weight: bold;
  color: white;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
  transform: translate(-50%, -50%);
  z-index: 5;
  padding: 5px 10px;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}

.click-point {
  position: absolute;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 14px;
  font-weight: bold;
  transform: translate(-50%, -50%);
  z-index: 10;
}

.modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.refresh-btn {
  margin-right: 10px;
}

.confirm-btn {
  flex: 1;
}
</style>